import { z } from 'zod';

// === Irrigation Template Schema ===

export const IrrigationTemplateSchema = z.object({
  id: z.string().uuid(),
  company_id: z.string().uuid(),
  name: z.string().min(1).max(255),
  block_id: z.string().uuid(),
  rate_value: z.number().positive(),
  ml_per_hour: z.number().positive(),
  total_hectares: z.number().positive().multipleOf(0.001),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type IrrigationTemplate = z.infer<typeof IrrigationTemplateSchema>;

export const IrrigationTemplateInsertSchema = IrrigationTemplateSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
});
export type IrrigationTemplateInsert = z.infer<typeof IrrigationTemplateInsertSchema>;

// === Irrigation Cost Calculation ===

export const IrrigationCostSchema = z.object({
  rate_value: z.number().positive(),
  ml_per_hour: z.number().positive(),
  total_hectares: z.number().positive().multipleOf(0.001),
});

export type IrrigationCost = z.infer<typeof IrrigationCostSchema>;
